import React from 'react';
import { useDispatch } from 'react-redux';
import type { Claim } from '../../api/claims/interface';
import { StoreState, useSelector } from '../../data/store';
import { actions } from './data/logic';

interface ClaimOverviewHookState {
  claimMetadata?: Claim;
  isDrawerOpen: boolean;
  actions: StoreState['claim-overview']['actions'];
}

interface ClaimOverviewHookHandler {
  fetchClaim(): void;
  beginProcessing(): void;
  setDrawerOpen: (isOpen: boolean) => void;
}

const useClaimOverviewHook = (
  dossierId: string
): [ClaimOverviewHookState, ClaimOverviewHookHandler] => {
  const {
    claimMetadata,
    isDrawerOpen,
    actions: claimOverviewActions,
  } = useSelector((s: StoreState) => s['claim-overview']);
  const dispatch = useDispatch();

  const handler = React.useMemo(
    () => ({
      fetchClaim: () => {
        dispatch(actions.fetchClaim({ dossierId }));
      },
      beginProcessing: () => {
        dispatch(actions.beginProcessing({ dossierId }));
      },
      setDrawerOpen: (isOpen: boolean) => {
        dispatch(actions.setDrawerOpen(isOpen));
      },
    }),
    [dossierId, dispatch]
  );

  return [
    {
      claimMetadata: claimMetadata[dossierId],
      isDrawerOpen,
      actions: claimOverviewActions,
    },
    handler,
  ];
};

export default useClaimOverviewHook;
